module.exports = __webpack_public_path__ + "static/media/MiniHeliosOrleans2013.0654e8d9.JPG";